import { useQuery } from '@tanstack/react-query';
import { getUserContacts } from '@uplift/api';

export const useProviderContacts = (providerId?: string, enabled = true) => {
  return useQuery([ 'user', providerId, 'contacts' ], async () => {
    if (!providerId) {
      return [];
    }

    const response = await getUserContacts(providerId);

    response.data.sort((a, b) => a.name.localeCompare(b.name));

    return response.data.filter(c => c.value);
  }, {
    enabled: enabled,
  });
};
